import React from 'react';
import { loaderType } from '@src/v3/interfaces/components/loader';
import LoaderIcon from './LoaderIcon';

/**
 * Component to display loader and block screen with black background
 *
 * @param { Boolean } props.isVisible
 * @returns Node
 */
const Loader = ({ isVisible = false }: loaderType) => {
  return isVisible ? (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full sm:h-screen max-sm:h-[100dvh] z-[9999] overflow-hidden bg-white/75 flex flex-col items-center justify-center">
      <div className="flex justify-center items-center">
        <div className="relative ">
          <LoaderIcon />
        </div>
      </div>
    </div>
  ) : null;
};

export default Loader;
